import { Loading } from "components/shared";
import React, { useEffect } from "react";
import useMagicAction, { RESULT_SCHEMA, asText } from "./useMagicAction";


const MakeShorter = (props) => {

    const { run, input, writeBackReplace, closeMenu } = useMagicAction(props);

    useEffect(() => {
        run({
            prompt: `Rewrite the following text to be shorter while preserving its meaning, tone, emojis, hashtags and URLs.\n\nTEXT:\n${input}`,
            schema: RESULT_SCHEMA,
        })
            .then((r) => writeBackReplace(asText(r)))
            .finally(closeMenu);
    }, []);

    return (
        <div className="flex items-center justify-center p-4 gap-2">
            <Loading type={'element'} />
        </div>
    )
}

export default MakeShorter;
